import { render, staticRenderFns } from "./SubAdminTop.vue?vue&type=template&id=2de3cfa7&"
import script from "./SubAdminTop.vue?vue&type=script&lang=js&"
export * from "./SubAdminTop.vue?vue&type=script&lang=js&"
import style0 from "./SubAdminTop.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VContainer,VProgressLinear})
